import { render, staticRenderFns } from "./CustomerBasicInfoPanel.vue?vue&type=template&id=8e99f6e4&"
import script from "./CustomerBasicInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./CustomerBasicInfoPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports